import { Chart, registerables } from 'chart.js';
import { format } from 'date-fns';
import React, { useRef, useEffect, useState } from 'react';
import { apiEmbalei } from '../../../Services/api';

Chart.register(...registerables);

const ChartComponent = ({ date, endDate }) => {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);
  const [dataPedidos, setDataPedidos] = useState([]);

  const isDate = (date) => {
    return (new Date(date) !== "Data inválida!") && !isNaN(new Date(date));
  }

  const getData = async () => {
    if (!date || !endDate || !isDate(date) || !isDate(endDate)) return
    try {
      const res = await apiEmbalei.get(`graphics?data=${format(new Date(date), "yyyy-MM-dd")}&enddata=${format(new Date(endDate), "yyyy-MM-dd")}`);
      setDataPedidos(res.data);
    } catch(e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getData();
  }, [date, endDate]);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (chartRef.current) {
      chartRef.current.destroy();
    }

    const ctx = canvasRef.current.getContext('2d');
    chartRef.current = new Chart(ctx, {
      type: 'bar',
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
      data: {
        labels: dataPedidos.map(item => format(new Date(item.date), "dd/MM/yyyy")),
        datasets: [{
          backgroundColor: 'rgba(128, 128, 128, 0.2)',
          label: 'Pedidos',
          data: dataPedidos.map(item => item.total_orders),
        },
        {
          backgroundColor: 'rgba(64, 64, 64, 0.5)',
          label: 'Total de itens',
          data: dataPedidos.map(item => item.total_itens),
        }],
      },
    });
  }, [dataPedidos]);

  return <canvas ref={canvasRef}></canvas>;
};

export default ChartComponent;
